import { Component, Input } from '@angular/core';

@Component({
  selector: 'heitown-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  @Input()
  show?: boolean = false;
}
